/**
 * 사용자 관리 관련 상수 정의
 * 사용자 관리 탭, 필터 값 등을 중앙에서 관리
 */

// ============================================
// 사용자 관리 탭
// ============================================
export const USER_MANAGEMENT_TABS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  CUSTOMERS: 'customers',
  ALL: 'all',
  BLOCKED: 'blocked',
  SETTINGS: 'settings',
} as const;

// ============================================
// 필터 값
// ============================================
export const FILTER_VALUES = {
  ALL: 'all',
  NONE: 'none',
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  PENDING: 'pending',
  INVITED: 'invited',
  DELETED: 'deleted',
} as const;

// ============================================
// 타입 정의
// ============================================
export type UserManagementTab = typeof USER_MANAGEMENT_TABS[keyof typeof USER_MANAGEMENT_TABS];

// ============================================
// 비밀번호 길이 — 서버 규칙(backend/core/auth/password_policy.py)과 같게 둔다 (#292)
// 서버는 8자 이상 · 72바이트 이하. 화면은 32자까지만 받는다
// ============================================
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 32;
export const PASSWORD_LENGTH_MESSAGE = `비밀번호는 ${PASSWORD_MIN_LENGTH}자 이상 ${PASSWORD_MAX_LENGTH}자 이하여야 합니다.`;
